import * as s from './style'

import { Line } from 'react-chartjs-2';
import Filter from './filter/filter';

function Graphic(){

    const data = {
    labels: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO','SET', 'OUT', 'NOV', 'DEZ'],
    datasets: [
        {
        label: '',
        data: [0,50, 100, 30, 150, 100,400,150, 100,400, 500,450],
        fill: {value: 0},
        backgroundColor: '#FDDBB7',
        borderColor: '#FF8B00',
        tension: 0.5,
        pointStyle:'line',
        
        },
        
    ],
    };

    const options = {
        plugins: {
            legend: {
              display: false,
                
            }
          }  
    }

    return(
        <s.container>
            
            <div className='container-filter'>
                <label htmlFor='date'>
                    Filtrar por:

                    
                </label>
                <input type='date' name='date' id='date' />
                <Filter name={'Ano'} />
                <Filter name={'Mês'}/>
                <Filter name={'Semana'}/>


            </div>
            <Line className='chart' id='chart' data={data} options={options}/>
        </s.container>
    )
}

export default Graphic